import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoteAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"note_alt"}/>
}
